import React from 'react'
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined'
import DashboardStatCard from './DashboardStatCard'
import { useDashboardStatsCard } from '../../store/dashboardStats'
import type { DashboardStatCardStationProps } from './types'

const UnreadMessagesCard: React.FC<DashboardStatCardStationProps> = ({ stationId }) => {
  const { value, loading, error } = useDashboardStatsCard(stationId, 'unreadTotal')

  return (
    <DashboardStatCard
      title="Unread messages"
      value={value}
      loading={loading}
      error={error}
      icon={MarkEmailUnreadOutlinedIcon}
    />
  )
}

export default UnreadMessagesCard
